<template>
  <b-modal
    v-model="fileSetting.modal" size="xl" scrollable width="100%" centered dialog-class="wd-100p"
    title="Тохиргоо"
    @hidden="closeSettings()"
  >
    
    <div class="d-flex" v-if="!interactiveToggle">
      <form class="pd-20" style="width: 30%">
      <div class="form-group mg-b-0 row">
        <label class="col-form-label pd-t-20 d-block">Харагдах нэр</label>
        <input
          v-model="fileSetting.obj.title"
          maxlength="450"
          class="form-control"
          placeholder="Харагдах нэр"
        />
      </div>
      <div
        class="form-group mg-b-0 row"
        v-if="boxId != undefined && boxId != null && boxId > 0"
      >
        <label class="col-form-label pd-t-20 d-block">Эрэмбэ</label>
        <input
          v-model="fileSetting.obj.ord"
          class="form-control"
          placeholder="Эрэмбэ"
        />
      </div>
      <div
        class="form-group mg-b-0 row"
        v-if="boxId != undefined && boxId != null && boxId > 0"
      >
        <label class=" col-form-label pd-t-20 d-block">Хугацаа</label>
        <input
          v-model="fileSetting.obj.duration"
          type="number"
          class="form-control"
          placeholder="Хугацаа"
        />
      </div>

      <div
        class="form-group mg-b-0 row"
        v-if="boxId != undefined && boxId != null && boxId > 0"
      >
        <label class=" col-form-label pd-t-20 d-block">Ковер</label>
        <simple-uploader
          :propObjectId="6"
          :propObjectTypeId="6"
          @on-success="fileUploadedSetting"
          class="wd-100p"
        >
          <div slot="trigger" class="wd-100p">
            <a
              v-if="
                fileSetting.cover.uploadedAttachmentId == 0 ||
                  fileSetting.cover.uploadedAttachmentId == null
              "
              class="dropdown-item"
              >Компьютероос хуулах</a
            >
            <a v-else class="dropdown-item">
              <img
                :src="`${fileSetting.cover.uploadedUrl}?w=160&h=120&mode=crop`"
              />
            </a>
          </div>
          <!-- <div v-else slot="content" class="wd-100p">
                    
            </div>-->
        </simple-uploader>
      </div>
      <div class="form-group mg-b-0 row">
        <label class=" col-form-label pd-t-20 d-block mg-r-10">Төлөв</label
        ><br />
        <b-form-checkbox
          @change="publicOnChange"
          switch
          v-model="fileSetting.obj.isPublic"
        >
          <template v-if="fileSetting.obj.isPublic">
            Нээлттэй
            <b>(татах боломжтой)</b>
          </template>
          <template v-else>
            Цоожтой
            <b>(татах боломжгүй)</b>
          </template>
        </b-form-checkbox>
      </div>
      <!-- {{fileSetting.obj}} -->
      </form>
      

       <form class="pd-l-20 pd-r-20">
        <div
          class="form-group mg-b-0 row"
          v-if="boxId != undefined && boxId != null && boxId > 0"
        >
          <label class=" col-form-label pd-t-20 d-block">Тайлбар</label>
          <summernote
            v-model="fileSetting.obj.description"
            :text="fileSetting.obj.description"
          ></summernote>
        </div>
      </form>
    </div>

    <div v-show="interactiveToggle">
        <div>
          <div class="mg-b-10 d-flex">
            <a @click="fileSetting.obj.b1=!fileSetting.obj.b1" role="button">Видеог гүйлгэхгүйгээр дуусгах
              <feather v-if="fileSetting.obj.b1" type="toggle-right" class="text-success"></feather>
              <feather v-else type="toggle-left"></feather>
            </a>
            <a @click="fileSetting.obj.b2=!fileSetting.obj.b2" role="button" class="mg-l-auto">Дасгал ажлыг заавал ажиллаж видеог дуусгах
              <feather v-if="fileSetting.obj.b2" type="toggle-right" class="text-success"></feather>
              <feather v-else type="toggle-left"></feather>
            </a>
          </div>
        </div>
        <div class="d-flex mg-b-10 bd-b bg-gray-100 pd-10">
          <div>
              Одоогийн сан: <span class="font-weight-bold">{{interactiveObj.formId > 0 ? interactiveObj.formName : 'сан холбогдоогүй байна'}}</span>
          </div>
          <a @click="changeCurForm()" class="btn btn-primary btn-xs mg-l-auto">{{interactiveObj.formId > 0 ?'Тестийн санг солих':'Шинэ тестийн сан холбох'}}</a>
        </div>
        <div class="d-flex">
          <div style="width: 50%" class="pd-r-10">
            <ul>
              <li v-for="(o,i) in interactiveObj.interactives" :key="i" class="list-group-item d-flex align-items-center">
                <!-- <div class="avatar"><span class="wd-30 avatar-initial rounded-circle">{{o.second}}</span></div> -->
                <div class="bd-r pd-r-10 mg-r-10 wd-50 text-left">
                  <feather type="clock"></feather>
                  <sup> {{o.second}}</sup>
                </div>
                <div>
                  <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                    <feather v-if="o.type==1" type="pen-tool"></feather>
                    <feather v-else-if="o.type==2" type="file"></feather>
                    <feather v-else-if="o.type==3" type="file-text"></feather>
                  </h6>
                  <!-- <span class="d-block tx-11 text-muted" v-html="o.description"></span> -->
                  <span class="d-block tx-11 text-muted" v-if="o.type==1">асуулт</span>
                  <span class="d-block tx-11 text-muted" v-else-if="o.type==2">файл</span>
                  <span class="d-block tx-11 text-muted" v-else-if="o.type==3">текст</span>
                </div>
                <div class="mg-l-auto button-group" role="button">
                  <a @click="editInteractive(o, i)" class="text-primary">
                    <feather type="settings"></feather>
                  </a>
                  <a @click="removeInteractive(o, i)" class="mg-l-5 text-danger" role="button">
                    <feather type="trash-2"></feather>
                  </a>
                </div>
                <div v-if="o.objectId==0">0</div>
              </li>
            </ul>

          </div>
          <div class="mg-l-auto">
            <video
            :id="`video_hls_plyr_${id}`"
              controls="true"
              :style="`width: 100%; height: 400px`"
            ></video>
            <div class="d-flex ">
              <div>секунд: {{seccCur}}</div>
              <div class="btn-group mg-l-auto">
                <a @click="linkInteractive(1)" class="btn btn-xs btn-primary btn-uppercase">Файл холбох</a>
                <a @click="linkInteractive(2)" class="btn btn-xs btn-warning btn-uppercase">Асуулт холбох</a>
                <a @click="linkInteractive(3)" class="btn btn-xs btn-info btn-uppercase">тэмдэглэл харуулах</a>
              </div>
              
            </div>
          </div>
          
        </div>
      </div>
   

    <template #modal-footer>
       <div v-if="getFileMode(fileSetting.obj.ext)=='video' && hasStreamServer">
          <a @click="interactiveToggleSet()" role="button">Интерактив тохиргоо
            <feather v-if="!interactiveToggle" type="toggle-left"></feather>
            <feather v-else type="toggle-right" class="text-success"></feather>
          </a>
        </div>
        <div class="mg-l-auto">
          <b-button @click="fileSetting.modal = false" variant="danger" class="mg-r-10">Болих</b-button>
          <b-button @click="updateFileInfo" variant="primary">Хадгалах</b-button>
        </div>
      
    </template>

    <media-finder
      v-if="mediaFinder.show > 0"
      @on-attach="fileAttached"
      @on-task-close="mediaFinder.show = 0"
    ></media-finder>

    <b-modal v-model="interactiveObj.curInttrActvEdt" title="Тохиргоо" scrollable>
      <template v-if="interactiveObj.curInttrActvInd!=null && interactiveObj.interactives.filter(x=>x.objectId==interactiveObj.curInttrActvId).length">
        <div class="d-flex align-items-center mg-b-10">
          <div class="pd-r-10">Секунд: </div>
          <input v-model="interactiveObj.interactives[interactiveObj.curInttrActvInd]['second']" 
          @keydown="secHandler" class="mg-l-auto form-control wd-100" />
        </div>
        <div v-if="interactiveObj.interactives[interactiveObj.curInttrActvInd]['type']==1" class="bd-y bg-gray-50 pd-y-10">
          <div class="d-flex align-items-center mg-b-10">
            <div class="pd-r-10">Буруу хариулвал буцах эсэх ? </div>
            <a @click="interactiveObj.interactives[interactiveObj.curInttrActvInd]['isBack']=!interactiveObj.interactives[interactiveObj.curInttrActvInd]['isBack']" role="button" class="mg-l-auto">
             <feather v-if="interactiveObj.interactives[interactiveObj.curInttrActvInd]['isBack']==true" type="toggle-right" class="text-primary"></feather>
             <feather v-else type="toggle-left"></feather>
             </a>             
          </div>
          <div class="d-flex align-items-center mg-b-10" v-if="interactiveObj.interactives[interactiveObj.curInttrActvInd]['isBack']==true" >
            <div class="pd-r-10">Буруу хариулвал буцах секунд: </div>
            <input v-model="interactiveObj.interactives[interactiveObj.curInttrActvInd]['backSecond']" class="mg-l-auto form-control wd-100" />
          </div>

          <div class="pd-10 text-muted">
            <div class="bd-b">Асуулт</div>
            <div v-html="interactiveObj.interactives[interactiveObj.curInttrActvInd]['description']" class="font-weight-bold"></div>
            <div class="bd-b">Хариултууд</div>
            <ul class="list-group">
              <li :key="qi" class="list-group-item" v-html="qa.s1"
                v-for="(qa, qi) in interactiveObj.questions.filter(x=>x.id==interactiveObj.interactives[interactiveObj.curInttrActvInd]['objectId'])[0]['a']"></li>
            </ul>
          </div>
        </div>
        <summernote v-else-if="interactiveObj.interactives[interactiveObj.curInttrActvInd]['type']==3" 
          v-model="interactiveObj.interactives[interactiveObj.curInttrActvInd]['description']" 
          :text="interactiveObj.interactives[interactiveObj.curInttrActvInd]['description']" ></summernote>

      </template>
      <!--  -->
      <template #modal-footer>
        <a @click="resumePlayer()" class="btn" role="button">
          <feather :type="interactiveObj.playrStts"></feather>
        </a>
        <div class="mg-l-auto">
          <b-button @click="interactiveObj.curInttrActvInd=null; interactiveObj.curInttrActvEdt=false" variant="danger" class="mg-r-10">Болих</b-button>
          <b-button @click="editInteractiveAftr()" variant="primary">Хадгалах</b-button>
        </div>
      </template>
    </b-modal>

    <form-finder
      v-if="interactiveObj.showFinder"
      :prms="interactiveObj.finderParams"
      @on-form-selected="linkForm"
      @on-close="interactiveObj.showFinder = false"
    />

    <b-modal title="Асуулт тохируулах" v-model="frmMgr.show" scrollable >
      <ul class="list-group">
        <li v-for="(q,i) in interactiveObj.questions.filter(x=>x.second==0 || x.second==null)" :key="i" class="list-group-item d-flex align-items-center">
          <div class="pd-r-10">{{i+1}}.)</div>
          <div v-html="q.s1"></div>
          <a @click="setSecOfQstn(q)" role="button" class="mg-l-auto pd-l-10"><feather type="cast" class="text-primary"></feather></a>
        </li>
      </ul>
      <template #modal-footer>Одоогийн секунд: {{seccCur}}</template>
    </b-modal>
  </b-modal>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { getFileMode, hasOneOf } from "@/libs/tools";
import Hls from "hls.js";

var player;

export default {
  components: {
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    summernote: () => ({
      component: import("@/components/modules/editor/summernote"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    mediaFinder: () => ({
      component: import("@/components/modules/media/finder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formFinder: () => ({
      component: import("@/views/modules/form/finder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  props: {
    id: {
      type: Number,
      default: () => 0
    },
    boxId: {
      type: Number,
      default: () => 0
    },
    obj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      seccCur: null,
      interactiveToggle: false,
      playerReady:false,
      hasStreamServer: true,
      cdnBaseUrl: "https://cdn.gosmart.mn/",
      streamBaseUrl: "",
      fileSetting: {
        modal: false,
        obj: {},
        cover: {
          uploadedAttachmentId: 0,
          uploadedUrl: ""
        }
      },
      destroyed: false,

      interactiveObj:{
        formId: null,
        questions: [],
        interactives: [],
        curInttrActvInd: null,
        curInttrActvId: null,
        curInttrActvEdt: false,
        playrStts: 'play',

        formName: null,
        showFinder: false,
        finderParams: {
          mode: 50,
          objectTypeId: 800
        },
      },

      mediaFinder: {
        show: false,
        id: 0,
        key: 0
      },

      frmMgr:{
        show: false,
      }
    };
  },
  beforeDestroy() {
    this.fnBefDestroy();
    //Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    if (this.id > 0) this.onSetting();

    if (this.$store.state.app.activeGroup.hasStreamServer != undefined && !this.$store.state.app.activeGroup.hasStreamServer) {
      this.hasStreamServer = false;
    }
  },
  methods: {
    configure() {
      if (this.$store.state.app.activeGroup.streamBaseUrl != undefined && this.$store.state.app.activeGroup.streamBaseUrl != "") {
        this.streamBaseUrl = this.$store.state.app.activeGroup.streamBaseUrl;
      }

      if (this.$store.state.app.activeGroup.cdnBaseUrl != undefined && this.$store.state.app.activeGroup.cdnBaseUrl != "") {
        this.cdnBaseUrl = this.$store.state.app.activeGroup.cdnBaseUrl;
      }
    },
    convertMp4ToHls(mp4Url) {
      const url = new URL(mp4Url);

      // path-ийг folder болон filename гэж задална
      const parts = url.pathname.split("/");

      // Эцсийн файл (videoName.mp4)
      const filename = parts.pop();

      // filename-ээс mp4-г m3u8 болгоно
      const hlsFilename = filename.replace(/\.mp4$/i, ".m3u8");

      // hls folder-ийг filename-ийн өмнө нэмнэ
      parts.push("hls", hlsFilename);

      // URL path-г шинэчилнэ
      url.pathname = parts.join("/");

      return url.toString();
    },
    getFileMode(ext){
      return getFileMode(ext);
    },
    fileUploadedSetting(e) {
      this.fileSetting.cover = e;
      this.fileSetting.obj.coverId = e.uploadedAttachmentId;
    },
    updateFileInfo() {
      request({
        data: {
          model: this.fileSetting.obj
        },
        api: { method: "POST", url: "boxInAttachment/PostInherited" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.activeFileId = 0;
          // this.init();
          this.fileSetting.modal = false;
        }
      });
      //console.log(this.fileSetting.cover);
    },
    onSetting() {
      //console.log("this.boxId", this.boxId);
      if (this.boxId != undefined && this.boxId != null && this.boxId > 0) {
        request({
          params: { boxId: this.boxId, attachmentId: this.id },
          api: { method: "GET", url: "boxInAttachment/GetInherited" },
          store: this.$store
        }).then(res => {
          if (res != false) {
            // console.log("boxInAttachment", res);
            this.fileSetting.obj = res.data.attachment;
            this.fileSetting.cover = {
              uploadedAttachmentId: res.data.attachment.coverId,
              uploadedUrl: res.data.attachment.coverUrl
            };
            this.fileSetting.modal = true;

            if((this.fileSetting.obj.b1!=undefined && this.fileSetting.obj.b1==true)
          || (this.fileSetting.obj.b2!=undefined && this.fileSetting.obj.b2==true)){
              this.configure();
              this.interactiveToggle= true;
              if (!this.destroyed) {
                this.fetchMediaPlayer(this.fileSetting.obj);
                this.fetchInteractives(this.id);
              }
            }

            // if(getFileMode(this.fileSetting.obj.ext)=='video'){
              
            // }
          }
        });
      } else {
        this.fileSetting.obj = this.obj;
        //console.log("onSetting", this.obj);
        this.fileSetting.modal = true;
      }
    },
    resumePlayer(){
      const video = document.getElementById(`video_hls_plyr_${this.id}`);
      if (!video) return;
      
      if(this.interactiveObj.curInttrActvEdt){
        try { 
          if(video.paused){
            this.interactiveObj.playrStts='pause';
            try { video.play(); } catch { }
          }else{
            this.interactiveObj.playrStts='play';
            try { video.pause(); } catch { }
          }
        } catch { }
      }else{
        if(video.paused){
          try { video.play(); } catch { }
        }else{
          try { video.pause(); } catch { }
        }
      }
    },
    secHandler(e){
      //console.log('e', parseInt(e.target.value, 10));
      const video = document.getElementById(`video_hls_plyr_${this.id}`);
      if (video) {
        try { video.currentTime = parseInt(e.target.value, 10); } catch { }
      }
    },
    fetchMediaPlayer(obj){
      let self= this;

      this.$nextTick(() => {
        var video;
        var url;
        
        // Always use HLS format
        url = this.convertMp4ToHls(obj.url);

        video = document.getElementById("video_hls_plyr_" + self.id);
        
        // Check if HLS is supported
        if (Hls.isSupported()) {
          player = new Hls({
            enableWorker: true,
            lowLatencyMode: false,
          });
          
          player.loadSource(url);
          player.attachMedia(video);
          
          player.on(Hls.Events.MANIFEST_PARSED, function() {
            //console.log('HLS manifest loaded');
            self.playerReady = true;
            setTimeout(() => {
              if(!self.interactiveObj.curInttrActvEdt){
                video.play();
              }
            }, 1000);
          });
          
          player.on(Hls.Events.ERROR, function(event, data) {
            if (data.fatal) {
              switch(data.type) {
                case Hls.ErrorTypes.NETWORK_ERROR:
                  //console.error('Network error');
                  player.startLoad();
                  break;
                case Hls.ErrorTypes.MEDIA_ERROR:
                  //console.error('Media error');
                  player.recoverMediaError();
                  break;
                default:
                  //console.error('Fatal error, cannot recover');
                  player.destroy();
                  break;
              }
            }
          });
          
          // Setup event listeners
          video.addEventListener('timeupdate', function() {
            self.onProgress({ time: video.currentTime });
          });
          
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          // Native HLS support (Safari, iOS)
          video.src = url;
          
          video.addEventListener('loadedmetadata', function() {
            self.playerReady = true;
            setTimeout(() => {
              if(!self.interactiveObj.curInttrActvEdt){
                video.play();
              }
            }, 1000);
          });
          
          video.addEventListener('timeupdate', function() {
            self.onProgress({ time: video.currentTime });
          });
        }
      });
    },
    closeSettings() {
      this.fnBefDestroy();
      
      this.$emit("on-close");
    },
    publicOnChange() {
      request({
        api: { method: "POST", url: "Media/FileSetIsPublic" },
        data: { id: this.id },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log("FileSetIsPublic=> ", res);
        }
      });
    },

    interactiveToggleSet(){
      if(this.interactiveToggle){
        this.interactiveToggle= false;
        this.fnBefDestroy();
      }else{
        this.configure();
        this.interactiveToggle= true;
        if (!this.destroyed) {
          this.fetchMediaPlayer(this.fileSetting.obj);
          this.fetchInteractives(this.id);
        }
      }
    },
    fnBefDestroy(){
      this.interactiveToggle= false;
      this.seccCur=null;
      this.destroyed = true;
      if (this.playerReady) {
        const video = document.getElementById(`video_hls_plyr_${this.id}`);
        if (video) {
          try {
            video.pause();
          } catch {}
        }
        // Destroy HLS instance if it exists
        if (player && typeof player.destroy === 'function') {
          player.destroy();
        }
      }
      this.fileReady = false;
    },
    fetchInteractives(aid, afterCode, afterItem){
      request({
        api: { method: "GET", url: "Media/GetInteractiveOption" },
        params: {
          id: aid
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log('GetInteractiveOption=> ', res);
          this.interactiveObj.interactives= res.data.config.interactives.filter(x=>x.second!=0);
          if(res.data.config.hasForm){
            this.fetchInteractiveForm(res.data.config.formId, afterCode, afterItem);
          }
        }
      });
    },
    fetchInteractiveForm(formId, afterCode, afterItem){
      this.interactiveObj.formId= formId;
      request({
        api: { method: "GET", url: "Form/GetLatestResponse" },
        params: {
          form: formId
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log('GetLatestResponse', res);
          this.interactiveObj.formName= res.data.name;
          this.interactiveObj.questions= res.data.questions;
          if(afterCode!=undefined && afterCode>0){
            this.editInteractive(this.interactiveObj.interactives.filter(x=>x.objectId==afterItem.objectId)[0], this.interactiveObj.interactives.map(st => st.objectId).indexOf(afterItem.objectId));
          }
        }
      });
    },

    onProgress(e){
      this.seccCur= parseInt(e.time, 10);
      //console.log(this.interactiveObj.curInttrActvInd, this.interactiveObj.curInttrActvEdt , this.interactiveObj.curInttrActvInd>0 && this.interactiveObj.curInttrActvEdt);
      //console.log('e', e, this.interactiveObj.curInttrActvInd);
      if(this.interactiveObj.curInttrActvId>0 && this.interactiveObj.curInttrActvEdt){
        //console.log('curr avtive opn');
        let _obj= this.interactiveObj.interactives.filter(x=> x.objectId==this.interactiveObj.curInttrActvId);
        if(_obj.length){
          _obj[0].second= this.seccCur;
        }
      }
    },
    linkInteractive(mode){
      const video = document.getElementById(`video_hls_plyr_${this.id}`);
      if (video) {
        try { video.pause(); } catch {};
      }

      let errs=[];
      if(this.seccCur<=0){
        errs.push('Видеог тоглуулж интерактив холбо секунд дээр зогсооно уу !');
      } else if(hasOneOf(this.interactiveObj.interactives.map(x=> { return x.second }), [this.seccCur])){
        errs.push('Энэ секундэд өмнө интерактив холбогдсон байна');
      }

      if(errs.length==0){
        if(mode==1){
          this.mediaFinder.show = true;
        } else if(mode==2){
          this.frmMgr.show = true;
        } else if(mode==3){
          let _obj= { 
            "type": 3, 
            "second": this.seccCur, 
            "objectId": 0, 
            "description": "", 
            "isBack": false, 
            "backSecond": null, 
            "isDone": false, 
            "isShow": false 
          };
          this.interactiveObj.interactives.push(_obj);
          this.editInteractive(_obj, this.interactiveObj.interactives.map(st => st.objectId).indexOf(0));
        }
      }else{
        alert(errs[0]);
      }
    },

    fileAttached(e) {
      if(hasOneOf(this.interactiveObj.interactives.map(x=> { return x.second }), [this.seccCur])){
        alert('Энэ секундэд өмнө интерактив холбогдсон байна');
        this.mediaFinder.show=false;
      }else{
        let _obj= { 
          "type": 2, 
          "second": this.seccCur, 
          "objectId": e, 
          "description": "", 
          "isBack": false, 
          "backSecond": null, 
          "isDone": false, 
          "isShow": false 
        };
        this.interactiveObj.interactives.push(_obj);
        this.mediaFinder.show=false;
        this.renewInteractiveOptions();
      }
    },
    renewInteractiveOptions(afterCode, afterItem){
      //console.log('this.interactiveObj.interactives', this.interactiveObj.interactives);
      request({
        data: { mainAttachId: this.id, formId: this.interactiveObj.formId, interactives: this.interactiveObj.interactives },
        api: { method: "post", url: "Media/PostInteractiveOption" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.mediaFinder.show = false;
          this.interactiveObj.interactives= [];
          const video = document.getElementById(`video_hls_plyr_${this.id}`);
          if (video) {
            try { video.pause(); } catch {};
          }
          this.fetchInteractives(this.id, afterCode, afterItem);
          if(afterCode!=undefined){
            if(afterCode==702){
              this.interactiveObj.showFinder= false;
            }else if(afterCode==808){
              this.frmMgr.show= false;
            }
          }
        }
      });
    },

    removeInteractive(o,i){
      const video = document.getElementById(`video_hls_plyr_${this.id}`);
      if (video) {
        try { video.pause(); } catch {};
      }

      if (confirm("устгахдаа итгэлтэй байна уу?")) {
        if(o.type==1){
          let i = this.interactiveObj.interactives.filter(st => st.objectId==o.objectId);
          if(i.length>0){
            i[0].second= 0;
          }
        }else{
          let i = this.interactiveObj.interactives.map(st => st.objectId).indexOf(o.objectId);
          this.interactiveObj.interactives.splice(i, 1);
        } 
        this.renewInteractiveOptions();
      }
    },
    editInteractive(o,i){
      if(!this.playerReady){
        alert('Видеог ачааллаж амжаагүй байна. Дахин оролдоно уу');
      } else {
        //console.log('editInteractive', i)
        const video = document.getElementById(`video_hls_plyr_${this.id}`);
        if (video) {
          try { video.pause(); } catch {};
          try { video.currentTime = o.second; } catch { }
        }
        this.interactiveObj.curInttrActvId= o.objectId;
        this.interactiveObj.curInttrActvInd= i;
        this.interactiveObj.curInttrActvEdt= true;
      }
    },
    editInteractiveAftr(){
      //# todo uuruusuu busad gj nemeh
      if(hasOneOf(this.interactiveObj.interactives.filter(x=>x.objectId!=this.interactiveObj.curInttrActvId).map(x=> { return x.second }), [this.seccCur])){
        alert('Энэ секундэд өмнө интерактив холбогдсон байна');
        
        this.mediaFinder.show=false;
      }else{
        this.renewInteractiveOptions();
        this.interactiveObj.curInttrActvInd= null;
        this.interactiveObj.curInttrActvId= null;
        this.interactiveObj.curInttrActvEdt= false;
      }
    },
    checkBeforehas(){},
    changeCurForm(){
      const video = document.getElementById(`video_hls_plyr_${this.id}`);
      if (video) {
        try { video.pause(); } catch {};
      }

      if(this.interactiveObj.formId>0){
        let _qsts= this.interactiveObj.interactives.filter(x=>x.type==1 && x.second>0);
        if(_qsts.length>0){
          alert('Нийт '+_qsts.length+' асуулт тохируулсан байна. Сан солихын тулд та эхлээд тохируулсан асуултуудыг устгана уу !');
        }else{
          this.showFormLinker();
        }
      }else{
        this.showFormLinker();
      }
    },
    showFormLinker(){
      this.interactiveObj.showFinder= true;
    },
    linkForm(e){
      if(e.length){
        this.interactiveObj.formId= e[0];
        this.renewInteractiveOptions(702);
      }
    },

    setSecOfQstn(q){
      q.second= this.seccCur;
      let _obj= { 
        "type": 1, 
        "second": this.seccCur, 
        "objectId": q.id, 
        "description": q.s1, 
        "isBack": false, 
        "backSecond": null, 
        "isDone": false, 
        "isShow": false 
      };
      this.interactiveObj.interactives.push(_obj);
      this.renewInteractiveOptions(808, _obj);
    }
  },
  computed: {
    fileId() {
      return this.id;
    }
  },
  watch: {
    fileId(val) {
      if (val > 0) {
        this.onSetting();
      }
    }
  }
};
</script>

<style></style>
